module.exports = __webpack_public_path__ + "static/media/toolbar-hand.ecc578a4.svg";